module.exports = __webpack_public_path__ + "static/gouillart-545070bb9f14c935df0f37c21be4e797.png";